import React from "react";
import { css } from "aphrodite";
import styles from "./styles";
import { IconButton, Typography } from "@mui/material";
import backButtonIcon from "../../../assets/icons/backButtonIcon.svg";
import { useTranslation } from "react-i18next";

const MobileTitle = React.forwardRef(({
    iconSrc,
    title,
    onClickBackButton = () => {}
}, ref) => {
    const { t } = useTranslation(["translation"]);

    return (
        <div className={css(styles.container)}>
            <div className={css(styles.buttonDiv)}>
                <IconButton 
                    onClick={onClickBackButton}
                    className={css(styles.button)}
                    aria-label={t("back")}
                >
                    <img alt="" src={backButtonIcon} />
                </IconButton>
            </div>
            <div className={css(styles.titleDiv)}>
                <img alt="" src={iconSrc} width={26} height={26}/>
                <Typography
                    ref={ref}
                    variant="h3"
                    component="h1"
                    tabIndex={-1}
                >
                    {title}
                </Typography>
            </div>
        </div>
    );
});

MobileTitle.displayName = "MobileTitle";

export default MobileTitle;
